module.exports = __webpack_public_path__ + "static/insights-85c50f6a50f3174b72d9e0e531afd2d8.png";